module.exports = __webpack_public_path__ + "static/media/damlag_768.e6393233.jpg";